// utils/sessionManager.js
import { createSession } from "../services/api";
import { getFileInfo, getUserHistory, saveUserHistory } from "./storage";

const SESSION_KEY = "asksam_session";

export const saveSessionObj = (obj) => {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(obj));
  } catch (e) {
    
  }
};

export const getSavedSessionObj = () => {
  try {
    const s = localStorage.getItem(SESSION_KEY);
    return s ? JSON.parse(s) : null;
  } catch (e) {
   
    return null;
  }
};

export const clearSavedSession = () => {
  try {
    localStorage.removeItem(SESSION_KEY);
  } catch (e) {
  
  }
};

/**
 * Ensure there is a session for the user. If not present, call API to create it.
 * Returns session_id (string or number).
 */
export const ensureSessionForUser = async (userId) => {
 

  const saved = getSavedSessionObj();
  if (saved && String(saved.user_id) === String(userId) && saved.session_id) {
    return String(saved.session_id);
  }

  try {
    const resp = await createSession(userId);

    const sid = resp?.session_id ?? resp?.data?.session_id ?? null;
    const user_id = resp?.user_id ?? userId;
    if (!sid) {
     
      return null;
    }
    const obj = {
      user_id: String(user_id),
      session_id: String(sid),
      created_at: Date.now(),
    };
    saveSessionObj(obj);
    return String(sid);
  } catch (err) {
 
    throw err;
  }
};

export const forceCreateSessionForUser = async (userId) => {
  try {
    const resp = await createSession(userId);
    const sid = resp?.session_id ?? null;
    const user_id = resp?.user_id ?? userId;
    if (!sid) throw new Error("createSession returned no session_id");
    const obj = {
      user_id: String(user_id),
      session_id: String(sid),
      created_at: Date.now(),
    };
    saveSessionObj(obj);
    return String(sid);
  } catch (e) {
 
    throw e;
  }
};


const normalizeSession = (conv) => ({
  id: conv.Session_Id || conv.id || Date.now(),
  type: "conversation",
  name: conv.Title || conv.name || "New Chat",
  messages: conv.messages || [],
  rows: conv.rows || [],
  schema: conv.schema || null,
  timestamp: conv.timestamp || Date.now(),
});

// userId = current user
export const createNewChatIfAllowed = async (userId) => {
  if (!userId) return null;

  const history = getUserHistory(userId) || [];
  const lastSession = history[history.length - 1];

  // Prevent duplicate "New Chat"
  if (lastSession?.name === "New Chat") {
    
    return null;
  }

  // Decide whether to hit API
  const shouldHitApi =
    history.length === 0 ||
    (lastSession?.name && lastSession.name !== "New Chat");

  let newChat = null;

  if (shouldHitApi) {
    try {
      const sessionData = await createSession(userId);
      newChat = {
        id: sessionData.id,
        type: "conversation",
        name: sessionData.name || "New Chat",
        messages: [],
        timestamp: Date.now(),
      };
      // Save to history
      saveUserHistory(userId, [...history, newChat]);
      
    } catch (err) {
     
      return null;
    }
  } else {
    // Only add "New Chat" if history is empty or last session has no filename
    newChat = {
      id: Date.now(),
      type: "conversation",
      name: "New Chat",
      messages: [],
      timestamp: Date.now(),
    };
    saveUserHistory(userId, [...history, newChat]);
   
  }

  return newChat;
};
